/* Quilted Joy — Cart Progress Bar behavior (extracted from snippets/progress-bar.liquid).
   Loaded once and cached across pages. Per-page config (thresholds, gift product,
   etc.) is injected inline as window.qjPbConfig by the snippet. */
(function () {
  if (window.__qjPbReady) return;
  window.__qjPbReady = true;

  // ── Config — injected inline by Liquid (snippets/progress-bar.liquid) ──
  var CFG = window.qjPbConfig || {
    FREE_SHIPPING_THRESHOLD : 100,
    FREE_GIFT_THRESHOLD     : 0,
    GIFT_ENABLED            : false,
    GIFT_VARIANT_ID         : 0,
    GIFT_PROP_KEY           : '_qj_free_gift',
    GIFT_DISPLAY_NAME       : 'free gift',
    FREE_GIFT2_THRESHOLD    : 0,
    GIFT2_ENABLED           : false,
    GIFT2_VARIANT_ID        : 0,
    GIFT2_DISPLAY_NAME      : 'free gift'
  };
  var T1 = Math.round(CFG.FREE_SHIPPING_THRESHOLD * 100);
  var T2 = Math.round(CFG.FREE_GIFT_THRESHOLD * 100);
  var T3 = Math.round((CFG.FREE_GIFT2_THRESHOLD || 0) * 100);
  var GIFT2_ON = !!(CFG.GIFT2_ENABLED && CFG.GIFT_ENABLED);
  var BAR_MAX = CFG.GIFT_ENABLED ? Math.max(T1, T2) : T1;
  if (GIFT2_ON) BAR_MAX = Math.max(BAR_MAX, T3);
  var GIFT_FIRST = CFG.GIFT_ENABLED && T2 < T1;

  // ── Money formatting ─────────────────────────────────────────
  // Mirrors Liquid's money_without_trailing_zeros: whole dollars show exactly
  // as entered ($100), fractional amounts keep their cents ($56.50).
  function money(cents) {
    var d = cents / 100;
    return '$' + (d % 1 === 0 ? d.toFixed(0) : d.toFixed(2));
  }

  // ── Messages ─────────────────────────────────────────────────
  function getMessage(cents) {
    if (!CFG.GIFT_ENABLED) {
      if (cents < T1) return 'Spend ' + money(T1 - cents) + ' more for FREE shipping!';
      return "🎉 You've unlocked FREE shipping!";
    }

    if (GIFT2_ON) {
      // Two-tier mode — mirrors the Liquid message logic in progress-bar.liquid:
      // list what's unlocked, then the next (smallest unmet) milestone.
      var shipLabel = 'FREE shipping';
      var g1Label   = 'your FREE ' + CFG.GIFT_DISPLAY_NAME;
      var g2Label   = 'your FREE ' + CFG.GIFT2_DISPLAY_NAME;

      var unlocked = [];
      if (cents >= T2) unlocked.push(g1Label);
      if (cents >= T1) unlocked.push(shipLabel);
      if (cents >= T3) unlocked.push(g2Label);
      var unlockedJoin = unlocked.length === 3
        ? unlocked[0] + ', ' + unlocked[1] + ' AND ' + unlocked[2]
        : unlocked.join(' AND ');

      var nextCents = 0, nextLabel = '';
      if (cents < T1) { nextCents = T1; nextLabel = shipLabel; }
      if (cents < T2 && (nextCents === 0 || T2 < nextCents)) { nextCents = T2; nextLabel = g1Label; }
      if (cents < T3 && (nextCents === 0 || T3 < nextCents)) { nextCents = T3; nextLabel = g2Label; }

      if (nextCents === 0)       return "🎁 You've unlocked " + unlockedJoin + '!';
      if (unlocked.length === 0) return 'Spend ' + money(nextCents - cents) + ' more to get ' + nextLabel + '!';
      return "🎉 You've unlocked " + unlockedJoin + '! Spend ' + money(nextCents - cents) + ' more to get ' + nextLabel + '!';
    }

    if (GIFT_FIRST) {
      if (cents < T2) return 'Spend ' + money(T2 - cents) + ' more to get your FREE ' + CFG.GIFT_DISPLAY_NAME + ', then FREE shipping at ' + money(T1) + '*!';
      if (cents < T1) return '🎁 FREE ' + CFG.GIFT_DISPLAY_NAME + ' unlocked! Spend ' + money(T1 - cents) + ' more for FREE shipping!';
      return "🎉 You've unlocked your FREE " + CFG.GIFT_DISPLAY_NAME + ' AND free shipping!';
    } else {
      if (cents < T1) return 'Spend ' + money(T1 - cents) + ' more for FREE shipping + unlock a FREE ' + CFG.GIFT_DISPLAY_NAME + ' at ' + money(T2) + '*!';
      if (cents < T2) return '🎉 Free shipping unlocked! Spend ' + money(T2 - cents) + ' more to get your FREE ' + CFG.GIFT_DISPLAY_NAME + '!';
      return "🎁 You've unlocked FREE shipping AND your FREE " + CFG.GIFT_DISPLAY_NAME + '!';
    }
  }

  // ── Qualifying total (excludes gifts, gift cards, excluded collection) ──
  // Product ids excluded by the GWP Excluded Collection are computed server-side
  // and stamped on each rendered bar as data-excluded-pids (the drawer's bar
  // re-renders on every cart change, so this stays fresh). Union across bars:
  // excluding a product id that's no longer in the cart is a harmless no-op.
  function getExcludedPids() {
    var set = {};
    document.querySelectorAll('.qj-pb-wrapper[data-excluded-pids]').forEach(function (w) {
      (w.getAttribute('data-excluded-pids') || '').split(',').forEach(function (p) {
        p = p.trim();
        if (p) set[p] = true;
      });
    });
    return set;
  }

  function getQualifyingCents(cartData) {
    if (!cartData || !cartData.items) return 0;
    var exclPids = getExcludedPids();
    var total = 0;
    for (var i = 0; i < cartData.items.length; i++) {
      var item = cartData.items[i];
      // A line never counts toward thresholds if it is a configured gift variant
      // (while its tier is active), carries the legacy gift property, is a gift
      // card, or belongs to the GWP Excluded Collection — mirrors
      // progress-bar.liquid's qualifying_cents loop.
      var isExcluded = (CFG.GIFT_ENABLED && String(item.variant_id) === String(CFG.GIFT_VARIANT_ID))
                   || (GIFT2_ON && String(item.variant_id) === String(CFG.GIFT2_VARIANT_ID))
                   || (item.properties && item.properties[CFG.GIFT_PROP_KEY])
                   || item.gift_card
                   || exclPids[String(item.product_id)];
      if (!isExcluded) total += (item.final_line_price || 0);
    }
    return total;
  }

  // ── Label row packing (visual only) ─────────────────────────
  // All milestone labels sit below the bar. The server renders a
  // width-independent first guess of which labels need the second (lower) row;
  // here we re-measure the actual label boxes at the real rendered width and
  // keep every label on the single top row whenever it truly fits, dropping a
  // label to row 2 only when it would overlap its neighbor. Runs after every
  // bar update and on resize. Never touches positions, fill, or GWP logic.
  function fixLabelRows(wrapper) {
    if (!wrapper.offsetParent) return; // hidden (e.g. closed drawer): keep server guess
    var track = wrapper.querySelector('.qj-pb__track');
    var ms = [].slice.call(wrapper.querySelectorAll('.qj-pb__milestone'));
    if (!track || ms.length < 2) return;
    ms.forEach(function (m) { m.classList.remove('qj-pb__milestone--row2'); });
    ms.sort(function (a, b) { return (parseFloat(a.style.left) || 0) - (parseFloat(b.style.left) || 0); });
    var PAD = 8; // min horizontal gap between neighboring labels, px
    var end1 = -Infinity;
    var twoRow = false;
    ms.forEach(function (m) {
      var label = m.querySelector('.qj-pb__milestone-label');
      if (!label) return;
      var r = label.getBoundingClientRect();
      if (r.width === 0) return;
      if (r.left >= end1 + PAD) {
        end1 = r.right;
      } else {
        m.classList.add('qj-pb__milestone--row2');
        twoRow = true;
      }
    });
    track.classList.toggle('qj-pb__track--tworow', twoRow);
  }
  function fixAllLabelRows() {
    document.querySelectorAll('.qj-pb-wrapper').forEach(fixLabelRows);
  }
  var _rt;
  window.addEventListener('resize', function () {
    clearTimeout(_rt);
    _rt = setTimeout(fixAllLabelRows, 150);
  });

  // ── Update every bar instance on the page ───────────────────
  function updateAllBars(cartData) {
    var cents = getQualifyingCents(cartData);
    var pct   = Math.min((cents / BAR_MAX) * 100, 100).toFixed(2);
    var msg   = getMessage(cents);

    document.querySelectorAll('.qj-pb-wrapper').forEach(function (wrapper) {
      var fill  = wrapper.querySelector('.qj-pb__fill');
      var m1    = wrapper.querySelector('[data-milestone="shipping"]');
      var m2    = wrapper.querySelector('[data-milestone="gift"]');
      var m3    = wrapper.querySelector('[data-milestone="gift2"]');
      var msgEl = wrapper.querySelector('.qj-pb__message');
      var track = wrapper.querySelector('.qj-pb__track');

      if (fill)  fill.style.width = pct + '%';
      if (m1)    m1.classList.toggle('is-complete', cents >= T1);
      if (m2)    m2.classList.toggle('is-complete', cents >= T2);
      if (m3)    m3.classList.toggle('is-complete', cents >= T3);
      if (msgEl) msgEl.innerHTML = msg;
      if (track) track.setAttribute('aria-valuenow', cents);
    });
    fixAllLabelRows();
  }

  // ── Fetch cart then update ───────────────────────────────────
  function fetchAndUpdate() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateAllBars(cart); })
      .catch(function (e) { console.warn('[QJ Progress Bar]', e); });
  }

  var _t;
  function debouncedFetch() {
    clearTimeout(_t);
    _t = setTimeout(fetchAndUpdate, 400);
  }

  // ── Patch theme's own cart update function ───────────────────
  function patchRerenderUpsell() {
    var _orig = window.rerenderUpsellContainer;
    window.rerenderUpsellContainer = function (data) {
      if (_orig) _orig.call(this, data);
      debouncedFetch();
    };
  }
  if (typeof window.rerenderUpsellContainer === 'function') {
    patchRerenderUpsell();
  } else {
    var _pollCount = 0;
    var _poll = setInterval(function () {
      if (typeof window.rerenderUpsellContainer === 'function') {
        patchRerenderUpsell(); clearInterval(_poll);
      } else if (++_pollCount > 20) { clearInterval(_poll); }
    }, 100);
  }

  document.addEventListener('cart:updated',         function (e) { if (e.detail && e.detail.cart) updateAllBars(e.detail.cart); else debouncedFetch(); });
  document.addEventListener('cart-drawer:open',     debouncedFetch);
  document.addEventListener('shopify:section:load', debouncedFetch);

  var _drawerEl = document.getElementById('CartDrawer');
  if (_drawerEl && window.MutationObserver) {
    new MutationObserver(function () { debouncedFetch(); }).observe(_drawerEl, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fetchAndUpdate);
  } else {
    fetchAndUpdate();
  }
})();
